import { isCanceledOrDeleted } from "@stores/purchases/utils";
import { ReactElement } from "react";
import { Anchor, Box, List, Text } from "@mantine/core";
import { IPurchaseCardProps } from "../types";
import { CloudPurchaseCardHeader } from "../CloudPurchaseCard/CloudPurchaseCard.components";
import { PurchaseDetailSection } from "../section/PurchaseDetailSection/PurchaseDetailSection";
import { CanceledSubscriptionCard } from "../section/CanceledSubscriptionSection/CanceledSubscriptionSection";
import PurchaseCard from "../PurchaseCard/PurchaseCard";

export default function CloudDevPurchaseCard({
  purchase,
}: IPurchaseCardProps): ReactElement {
  const isPurchaseCanceledOrDeleted = isCanceledOrDeleted(purchase);

  return (
    <PurchaseCard purchase={purchase}>
      <CloudPurchaseCardHeader purchase={purchase} />
      <Box mt="lg">
        {isPurchaseCanceledOrDeleted ? (
          <CanceledSubscriptionCard purchase={purchase} />
        ) : (
          <PurchaseDetailSection purchase={purchase} />
        )}
      </Box>
      {!isPurchaseCanceledOrDeleted && (
        <Box>
          <Text mb="xs" mt="xl">
            Common next steps
          </Text>
          <List>
            <List.Item>
              <Anchor
                href="https://www.metabase.com/docs/latest/installation-and-operation/remote-sync"
                target="_blank"
                rel="noreferrer"
              >
                Push changes from staging to your production Metabase
              </Anchor>
            </List.Item>
          </List>
        </Box>
      )}
    </PurchaseCard>
  );
}
